/*
 * 1-Minute Maths
 * Copyright © 2021 - 2022 White Rose Maths
 * Dice5TenFrame.tsx - Ten frame with dice images for hint screen on web
*/

import { StyleSheet, View } from 'react-native';
import { calculateHorizontalTenFrameSize } from './TenFrameSizes';
import TenFrameElement from './TenFrameElement';

interface Dice5TenFrameProps {
  numFrames: number;
  answer: number;
  usableWidth: number;
  usableHeight: number;
}

const Dice5TenFrame = ({ numFrames, answer, usableWidth, usableHeight }: Dice5TenFrameProps): JSX.Element => {

  const {usableElementSize, elementMargin} = calculateHorizontalTenFrameSize(numFrames, usableWidth, usableHeight);

  let cols: JSX.Element[] = [];
  const rows: JSX.Element[] = [];

  let numFivesTop = Math.ceil(answer/2);
  let numFivesBottom = Math.floor(answer/2);

  // Put in the top row
  for (let i = 0; i < 5; i++) {
    if(numFivesTop > 0)
    {
      cols.push(
        <TenFrameElement image={require('../../../../assets/images/dice5.png')} key={`topfive${i}`} isFilled={false} color='none' width={usableElementSize} height={usableElementSize} margin={elementMargin} />
      );
      numFivesTop -= 1;
    }
    else 
    {
      cols.push(<TenFrameElement color='none' isFilled={false} key={`topempty${i}`} width={usableElementSize} height={usableElementSize} margin={elementMargin} />);
    }
  }

  rows.push(
    <View style={styles.row} key='row1'>
      {cols}
    </View>
  );

  cols = [];
  for (let i = 0; i < 5; i++) {
    if(numFivesBottom > 0)
    {
      cols.push(
        <TenFrameElement image={require('../../../../assets/images/dice5.png')} key={`bottomfive${i}`} isFilled={false} color='none' width={usableElementSize} height={usableElementSize} margin={elementMargin} />
      );
      numFivesBottom -= 1;
    }
    else 
    {
      cols.push(<TenFrameElement isFilled={false} key={`bottomempty${i}`} color='none' width={usableElementSize} height={usableElementSize} margin={elementMargin} />);
    }
  }

  rows.push(
    <View style={styles.row} key='row2'>
      {cols}
    </View>
  );

  return (
    <View style={styles.frameWrapper} key='tenFrameWrapper'>
      <View style={styles.tenFrame} key='tenFrame'>
        {rows}
      </View>
    </View>
  );
};

export default Dice5TenFrame;

const styles = StyleSheet.create({

  frameWrapper: {
    flex: 1,
    justifyContent: 'center',
    alignContent: 'center',
  },

  tenFrame: {
    alignItems: 'center',
    borderWidth: 2,
    borderColor: '#20232a',
    borderStyle: 'solid',
    backgroundColor: 'grey',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
    display: 'flex',
  },

  row: {
    flexDirection: 'row'
  }
});
